import React from "react";
import { PageHeader } from "../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import { Button, Container, Stack } from "react-bootstrap";
import { useCreateUserMutation } from "../../services/user";
import { UserForm } from "./UserForm";
import { useBasicDataQuery } from "../../services/basicData/basicData";

const CreateUser = () => {
  const { t } = useTranslation();

  const { data: basicDataRes, isLoading, isFetching } = useBasicDataQuery();
  const basicData = basicDataRes?.data?.data || {};

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError: setFormError,
  } = useForm({
    defaultValues: {
      city_id: 3,
      type: "employee",
      group_ids: [],
      system_ids: [],
    },
  });

  const loading = isLoading || isFetching;
  const { mutate: createUser, isPending } = useCreateUserMutation(setFormError);

  const onSubmit = (data) => {
    createUser(data);
  };

  return (
    <Stack>
      <PageHeader title={t("CREATE_USER")} />
      <Container fluid>
        <div className="m-4">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column gap-4"
          >
            <UserForm
              control={control}
              errors={errors}
              watch={watch}
              setValue={setValue}
              basicData={basicData}
              loading={loading}
            />

            <div>
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending && <Spinner size="sm" className="me-2" />}
                {t("ADD_USER")}
              </Button>
            </div>
          </form>
        </div>
      </Container>
    </Stack>
  );
};

export default CreateUser;
